import styled from "styled-components";
import { Box } from "@mui/material";

export const CMErrorContainer = styled.span((props) => ({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap'
}))

export const CMError = styled.span((props) => ({
  color: 'red',
  fontSize: props.fontSize || '14px',
  padding: '8px',
  display: 'flex',
  justifyContent: 'center',
  zIndex: '0',
  width:"100%",
  [`@media (min-width: 2000px)`]: {
    fontSize: "2vh",
  },
  [`@media (max-width: 992px)`]: {
    display: 'flex',
    justifyContent: 'center',
    left: '0',
    top: 'auto',
    transform: 'none',
  }
}))

export const CMHeadingContainer = styled.div((props) => ({
  display: "flex",
  flexDirection: "row",

  "& h3": {
    margin: 0,
    paddingLeft: 18,
    fontFamily: props.theme.fontFamilies.workSans,
    [`@media (min-width: 2000px)`]: {
      marginLeft:"2vh",
      fontSize: "3vh",
    },
  },
  "& h3 span": {
    color: "#A80000",
  },

  [`@media${props.theme.breakpoints.lg}`]: {
    flexDirection: "column",
  },

  [`@media${props.theme.breakpoints.xs}`]: {
    flexDirection: "column",
    "& h3": {
      fontSize: "1.2rem"
    },
    "& h3 span": {
      fontSize: "1.2rem",
      [`@media (min-width: 2000px)`]: {
        fontSize: "2.5vh",
      },
    },
  },
}));
export const CMDetails = styled.div((props) => ({
  display: "flex",
  position: "relative",
  marginTop: props.theme.spacers["1"],
  marginLeft: 18,
  h1: {
    margin: 0,
  },

  [`@media ${props.theme.breakpoints.lg}`]: {
    flexDirection: "row",
    textAlign: "center",
    marginLeft: 0,
  },
}));

export const CMCarouselContainer = styled.div((props) => ({
  width: "12%",
  paddingTop: 0,
  "& .swiper": {
    paddingBottom: "10%",
  },

  "& img": {
    width: 59,
    height: 59,
    [`@media (min-width: 2000px)`]: {
      width: "15vh",
      height:  "auto",
    },
  },
  [`@media (min-width: 2000px)`]: {
    marginLeft:"2vh",
  },
  [`@media ${props.theme.breakpoints.lg}`]: {
    minWidth: "71px",
  },
}));
export const CMAuctionDescription = styled.div((props) => ({
  paddingTop: "2%",
  paddingLeft: "2%",
  paddingBottom: 17,
  alignContent: "center",
  "& h5": {
    fontFamily: props.theme.fontFamilies.jost,
    fontWeight: "normal",
    [`@media (min-width: 2000px)`]: {
      fontSize: "2vh",
    },
  },
  "& h3": {
    fontSize: props.theme.fontSizes.h2,
    fontFamily: props.theme.fontFamilies.workSans,
    [`@media (min-width: 2000px)`]: {
      fontSize: "3vh",
    },
  },

  [`@media (min-width: 2000px)`]: {
    paddingTop: "0%",
  },

  [`${CMCardContainer}`]: {
    display: "none",
  },

  [`@media ${props.theme.breakpoints.lg}`]: {
    textAlign: "left",
    paddingTop: "3%",
    [`${CMCardContainer}`]: {
      width: "100%",
      display: "block",
      position: "unset",
      marginTop: props.theme.spacers["5"],
      marginBottom: props.theme.spacers["2"],

      "& > div > div": {
        width: "95%",
      },
    },
  },
}));
export const CMAuctionBalance = styled.div((props) => ({
  paddingTop: "2%",
  paddingLeft: "2%",
  paddingRight: "2%",
  paddingBottom: 17,
  alignContent: "center",
  textAlign: "center",
  marginRight: "12px",
  "& h5": {
    fontFamily: props.theme.fontFamilies.jost,
    fontWeight: "normal",
    [`@media (min-width: 2000px)`]: {
      fontSize: "2vh",
    },
  },
  "& h3": {
    fontSize: "18px",
    fontFamily: props.theme.fontFamilies.workSans,
    [`@media (min-width: 2000px)`]: {
      fontSize: "2.5vh",
    },
  },
  "& button": {
    [`@media (min-width: 2000px)`]: {
      fontSize: "3vh !important",
      width:"25vh !important",
      height:"5vh !important",
    },
  },

  [`${CMCardContainer}`]: {
    display: "none",
  },

  [`@media ${props.theme.breakpoints.lg}`]: {
    textAlign: "left",
    paddingTop: "5%",
    [`${CMCardContainer}`]: {
      width: "100%",
      display: "block",
      position: "unset",
      marginTop: props.theme.spacers["5"],
      marginBottom: props.theme.spacers["2"],

      "& > div > div": {
        width: "95%",
      },
    },
  },

}));
export const CMCardContainer = styled.div`
  width: 40%;
  position: absolute;
  right: 0;
  max-width: 453px;

  @media ${(props) => props.theme.breakpoints.lg} {
    display: none;
    max-width: 640px;
  }
`;
export const CMBox = styled(Box)((props) => ({
  textAlign: "left",
  backgroundColor: " #F3FAFC",
  borderRadius: 33,
  height: 193,
  marginTop: 39,
  padding: "0 40px",
  fontFamily: props.theme.fontFamilies.jost,
  fontWeight: "normal",
  "& .dollar-sign-box": {
    marginBottom: 0,
  },
  "& .container div.dollar-sign": {
    background: "white",
    fontSize: 32,
    border: "1px solid #ccc",
    position: "relative",

    width: 40,
    margin: "1px 0",
    textAlign: "center",
    lineHeight: "76px",

    [`@media (min-width: 2000px)`]: {
      fontSize: "4vh !important",
      width:"6vh !important",
      height:"4vh !important",
      lineHeight: "4vh !important",
      marginTop:"0px",
      border:"none",
      backgroundColor:"transparent"
    },
  },
  "& .table-container": {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    height: "auto",
    paddingTop: "2%",
    paddingLeft: "10px",

    "& .table-wrapper": {
      width: "100%",
      display: "flex",
      flexDirection: "row",
      [`@media ${props.theme.breakpoints.lg}`]: {
        display:"none !important"
      },
    },

    "& .row": {
      display: "flex",
      flexDirection: "column",
      marginRight: "60px",
      marginLeft: "15px",
      fontSize: 12,
      textAlign: "center",
      [`@media (min-width: 2000px)`]: {
        width: "13%",
      },
    },

    "& .minBid": {
      marginRight: "0px",
      display: "block",
      marginBottom: "5px"
    },
    "& .maxBid": {
      marginRight: "0px",
      display: "block",
      marginBottom: "5px"
    },
    "& .minUnit": {
      marginRight: "0px",
      display: "block",
      marginBottom: "5px",
      [`@media (min-width: 2000px)`]: {
        marginLeft: "4vh",
      },
    },
    "& .cell": {
      marginBottom: "2px",
      fontSize: 14,
      [`@media (min-width: 2000px)`]: {
        fontSize: "2vh",
      },
    },

    [`@media (min-width: 2000px)`]: {
      paddingTop:"7vh"
    },
    [`@media (max-width: 992px)`]: {

      "& .table-wrapper": {
        width: "100%",
        display: "flex",
        flexDirection: "row",
        justifyContent: 'center',
        alignItems: 'center'
      },
    },
    [`@media (max-width: 364px)`]: {
      "& .table-wrapper": {
        paddingLeft: '10px',
      },
    },

  },
  "& .container": {
    display: "flex",
    flexDirection: "row",
    paddingTop: "5%",
    paddingLeft: "20px",
    height: 100,
    fontWeight: "normal",
    "& div": {
      height: "100px",
      //marginBottom: "20px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      [`@media (min-width: 2000px)`]: {
        fontSize: "3vh",
        width:"65%",
        height:"auto !important"
      },
    },
    "& input": {
      height: "66px",
      width: "73px",
      padding: "5px",
      textAlign: "center",
      fontSize: 32,
      border: "1px solid #ccc",
      borderRadius: "5px",
      fontFamily: props.theme.fontFamilies.jost,
      [`@media (min-width: 2000px)`]: {
        fontSize: "3vh",
      },
    },

    "& .column1": {
      [`@media (min-width: 2000px)`]: {
        width:"8%"
        },
      "& input": {
        borderRight: "none",
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
        height: "66px",
        width: "60px",
        [`@media (min-width: 2000px)`]: {
          fontSize: "3vh !important",
        },
        },
      "& label": {
        [`@media (min-width: 2000px)`]: {
        height:"2.4vh"
        },
      }
    },
    "& .column2": {
      [`@media (min-width: 2000px)`]: {
        alignItems:"center"
       },
      "& div":{
        [`@media (min-width: 2000px)`]: {
          width:"100%",
          alignItems:"center"
         },
      },
      "& input": {
        borderTopLeftRadius: 2,
        borderBottomLeftRadius: 2,
        height: "66px",
        width: "113px",
        [`@media (min-width: 2000px)`]: {
          fontSize: "3vh !important",
          width:"10vh",
          height:"5vh"
        },
      },
      " & label": {
        display: "block",
        lineHeight: 1,
        paddingLeft: 12,
      },

      [`@media ${props.theme.breakpoints.lg}`]: {
        " & label": {
          marginLeft:"-100%"
        },
      },
    },
    "& .titleBids": {
      width: "80%",
      display: "none",
      marginTop: "15px",
      "& .titleBidsMin": {
        width: "50%",
        [`@media (min-width: 2000px)`]: {
          fontSize: "3vh !important",
        },
      },
      "& .titleBidsMax": {
        width:"50%",
        textAlign:"right",
        [`@media (min-width: 2000px)`]: {
          fontSize: "3vh !important",
        },
      },
      [`@media ${props.theme.breakpoints.lg}`]: {
        display:"flex"
      },
    },

    "& .contentBids": {
      width: "80%",
      display: "none",
      "& .titleBidsMin": {
        width: "50%",
        [`@media (min-width: 2000px)`]: {
          fontSize: "3vh !important",
        },
      },
      "& .titleBidsMax": {
        width:"50%",
        textAlign:"right",
        [`@media (min-width: 2000px)`]: {
          fontSize: "3vh !important",
        },
      },

      [`@media ${props.theme.breakpoints.lg}`]: {
        display:"flex"
      },
    },

    "& .titleBidsUnits": {
      width:"80%",
      display:"none",
      marginTop:"15px",
      "& .titleBidsMin": {
        width: "50%",
        [`@media (min-width: 2000px)`]: {
          fontSize: "3vh !important",
        },
      },
      "& .titleBidsMax": {
        width:"50%",
        textAlign:"right",
        [`@media (min-width: 2000px)`]: {
          fontSize: "3vh !important",
        },
      },
      [`@media ${props.theme.breakpoints.lg}`]: {
        display:"flex"
      },
    },

    "& .contentBidsUnits": {
      width: "80%",
      display: "none",
      "& .titleBidsMinUnits": {
        width:"50%", 
        paddingLeft:"20px",
        [`@media (min-width: 2000px)`]: {
          fontSize: "3vh !important",
        },
      },
      "& .titleBidsMaxUnits": {
        width:"50%", 
        textAlign:"right",
        paddingRight:"20px",
        [`@media (min-width: 2000px)`]: {
          fontSize: "3vh !important",
        },
      },
      [`@media ${props.theme.breakpoints.lg}`]: {
        display:"flex"
      },
    },


    "& .column3": {
      padding: "0 20px",
      justifyContent: "center",
      textAlign: "center",
      alignItems: "center",
      "& h3":{
        [`@media (min-width: 2000px)`]: {
        fontSize: "3vh !important",
      },
      },

      [`@media (min-width: 2000px)`]: {
        height: "8vh !important",
      },

      [`@media ${props.theme.breakpoints.lg}`]: {
        width: "100%",
        minHeight: "60px",
        "& h3": {
          backgroundColor: "rgb(116, 201, 50)",
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "60px",
          width: "60px",
          margin: "0 auto",
          color: "white",
        },

      },
    },
    "& .column4": {
      justifyContent: "space-between",
      "& label": {
        fontSize: 16,
        lineHeight: 1,
        [`@media (min-width: 2000px)`]: {
          fontSize: "3vh !important",
        },
      },
      "& div input": {
      [`@media (min-width: 2000px)`]: {
        fontSize: "3vh !important",
        width:"10vh !important",
        height:"5vh !important",
        lineHeight: "4vh !important"
      },
      },
      [`@media ${props.theme.breakpoints.lg}`]: {
        " & label": {
          textAlign:"left"
        },
      },
    },
    "& .column5": {
      padding: "0 40px",
      justifyContent: "center",
      textAlign: "center",

      "& h1": {
        fontSize: 31,
        justifyContent: "center",
        width: "100%",
        [`@media (min-width: 2000px)`]: {
          fontSize: "3vh !important",
        },
      },
      [`@media (min-width: 2000px)`]: {
        height: "8vh !important",
      },
      [`@media ${props.theme.breakpoints.lg}`]: {
        width: "100%",
        minHeight: "60px",
        "& h1": {
          backgroundColor: "rgb(116, 201, 50)",
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "60px",
          width: "60px",
          margin: "0 auto",
          color: "white",
        },
      },


      
    },
    "& .column6": {
      width: '100%',
      height: "100px",
      justifyContent: "left",
      textAlign: "left",


      " label": {
        fontSize: 32,
        justifyContent: "center",
        lineHeight: 1,
        [`@media (min-width: 2000px)`]: {
          fontSize: "2.5vh !important",
          lineHeight: 1,
        },
      },
      "& .CMTotal": {
        fontSize: 16,
        height: 25,
        [`@media (min-width: 2000px)`]: {
          height: "auto",
        },
      },
      "& .fee": {
        color: "rgb(168, 0, 0)",
        fontWeight: "800",
        fontSize: "16px",
        marginBottom: "8px",
        textAlign: "left",

        "& > span": {
          color: "rgb(168, 0, 0)",
          fontWeight: "800",
          fontSize: "14px",
          marginBottom: "8px",
          position: "absolute",
          marginLeft: "2px",
          marginTop: "1px",

        },
      },

    },
    [`@media (max-width: 992px)`]: {
      "& .column6": {
        width: '100%',
        height: "100px",
        justifyContent: "center",
        textAlign: "center",


        " label": {
          fontSize: 32,
          justifyContent: "center",
          lineHeight: 1,
        },
        "& .CMTotal": {
          fontSize: 16,
          height: 25,
        },
        "& .fee": {
          color: "rgb(168, 0, 0)",
          fontWeight: "800",
          fontSize: "16px",
          marginBottom: "8px",
          textAlign: "center",


        },

      },


    },
  },
  [`@media (min-width: 2000px)`]: {
    height: "auto",
    margin:"auto",
    width:"90%",
  },
  [`@media ${props.theme.breakpoints.lg}`]: {
    height: "auto !important",
    maxWidth: "610px",

    "& .container": {
      paddingRight: '20px',
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "center",
      alignItems: "center",
      height: "auto",

      [`@media${props.theme.breakpoints.lg}`]: {
        "& .column2": {
          textAlign: 'center',
          width: '80%',
        },

        "& .column4": {
          textAlign: 'center',
          width: '90%',
        },
      },

      [`@media${props.theme.breakpoints.sm}`]: {
        "& .column2": {
          textAlign: 'center',
          width: '80%',
          marginBottom: "0",
        },
      },

      [`@media${props.theme.breakpoints.xs}`]: {
        "& .column2": {
          textAlign: 'center',
          width: '70%',
          marginBottom: "0",
        },
      }
    },

    "& input": {
      width: "94% !important",
    },



  }
}));

export const CMOffer = styled.div((props) => ({
  display: "flex",
  justifyContent: "center",
  paddingTop: 41,
  paddingBottom: "77px",


  "& Button": {
    height: 53,
    width: 254,
    fontWeight: 500,
    fontFamily: props.theme.fontFamilies.jost,
    fontSize: 28,
    borderRadius: 30,
  },
  [`@media (max-width: 992px)`]: {
    paddingTop: 0,
    maxWidth:"700px"
  },
  "& h3": {
    paddingLeft: 9,
  },

  [`@media (max-width: 329px)`]: {
    paddingTop: 0,
    paddingLeft: 20
  }
}));



